import { forwardRef } from "react";
const SvgCheckCircle = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<circle cx={12} cy={12} r={11} stroke="currentColor" strokeWidth={2} /><path d="M7 11L11 15L17 9" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgCheckCircle);
export default ForwardRef;